import { Heading, Text } from 'ui-kit/typography'
import { LINKS } from 'routes/constants'
import { Link } from 'ui-kit/actions/link/Link'
import App from './app.svg'
import clsx from 'clsx'
import classes from './IntegrationMissingData.module.scss'

export function IntegrationMissingOperations() {
  return (
    <section className={classes.section}>
      <div className={classes.wrapper}>
        <Heading as={'h2'} size={'xl'} center>
          API Operations
        </Heading>
        <IntegrationMissingData
          text={'No API operations mapped for this app.'}
          linkText={'You can extract them from documentation using'}
        />
      </div>
    </section>
  )
}

export function IntegrationMissingDataCollections() {
  return (
    <section className={classes.section}>
      <div className={classes.wrapper}>
        <Heading as={'h2'} size={'xl'} center>
          Data Collections
        </Heading>
        <IntegrationMissingData
          text={'No data collections mapped for this app.'}
          linkText={'You can add them using'}
        />
      </div>
    </section>
  )
}

export function IntegrationMissingData({
  text,
  linkText,
  className,
}: {
  text: string
  linkText: string
  className?: string
}) {
  return (
    <div className={clsx(classes.cta, className)}>
      <img
        src={App.src}
        width={56}
        height={56}
        className={classes.cta_img}
        alt='Missing collections or operations?'
        loading='lazy'
      />
      <div className={classes.cta_desc}>
        <Text as={'span'} className={classes.cta_question}>
          {text}
        </Text>
        <Text as={'span'} size={'sm'} className={classes.cta_linkWrap}>
          {linkText}{' '}
          <Link type='noLineGradient' href={LINKS.CONNECTOR_BUILDER}>
            Connector Builder
          </Link>
        </Text>
      </div>
    </div>
  )
}
